import { Stack } from '@mui/material';
import Button from '@mui/material/Button';
import React, { useEffect, useState } from 'react';
import utilsRests from '../../../../MyConns/_Utils/utilsRests';
import BetweenDates from '../../../MySections/TimeSections/BetweenDates';



const BuisTollBar = (props) => {

    const [userBuis, setUserBuis] = useState();
    const [busissList, setBusissList] = useState([]);


    useEffect(() => {
        getBuisList();
    }, [])


    const getBuisList = async () => {
        let busiLst = await utilsRests.getRestsListSmall();

        setBusissList(busiLst)
    }

    const refreshTheList = (selectedBtn) => {
        props.refreshTheList(selectedBtn, userBuis)
    }

    return (
        <div className={"buisTollBar"}>
            <Button className={`btnBigMnu onLeft theSBtn`} variant="contained" onClick={() => {
                refreshTheList(props.selectedBtn);
            }}>
                רענן
            </Button>
            <Stack direction="row" spacing={2}>
                <div className={"btnMnuTop onRight"}>
                    <div className="col-md-12 onRight">
                        <div className="col-md-6 onRight">
                            <div className="spaceButtomBig ms-form-group my-0 mb-0 has-icon fs-14">
                                <input type="number" className="dtSearchInput ms-form-input" id="dtSearchInput1" name="dtSearchInput"
                                    placeholder="מספר הזמנה" value={props.srchText1}
                                    onChange={(e) => props.setSrchText1(e.target.value)}
                                    onKeyUp={(e) => props.checkIfEnter(e, "orderNUM")}
                                />
                                <Button className="dtSearchIcon flaticon-search text-disabled" onClick={() => props.searchOrder("orderNUM")} />
                            </div>
                        </div>
                        <div className="col-md-6 onRight">
                            <div className="spaceButtomBig ms-form-group my-0 mb-0 has-icon fs-14">
                                <input type="text" className="dtSearchInput ms-form-input" id="dtSearchInput2" name="dtSearchInput"
                                    placeholder="טלפון או שם לקוח" value={props.srchText2}
                                    onChange={(e) => props.setSrchText2(e.target.value)}
                                    onKeyUp={(e) => props.checkIfEnter(e, "byAll")}
                                />
                                <Button className="dtSearchIcon flaticon-search text-disabled" onClick={() => props.searchOrder("byAll")} />
                            </div>
                        </div>


                    </div>


                    <Button className={`btnBigMnu ${props.selectedBtn == 5 ? "selectedMnuBtn" : ""}`} variant="contained" onClick={() => refreshTheList(5)}>
                        ממתינות לאישור
                    </Button>
                    <Button className={`btnBigMnu ${props.selectedBtn == 6 ? "selectedMnuBtn" : ""}`} variant="contained" onClick={() => refreshTheList(6)}>
                        להיום ומחר
                    </Button>
                    <Button className={`btnBigMnu ${props.selectedBtn == 7 ? "selectedMnuBtn" : ""}`} variant="contained" onClick={() => refreshTheList(7)}>
                        עד סוף השבוע
                    </Button>

                    <Button className={`btnBigMnu ${props.selectedBtn == 8 ? "selectedMnuBtn" : ""}`} variant="contained" onClick={() => refreshTheList(8)}>
                        עד סוף החודש
                    </Button>
                    <Button className={`btnBigMnu ${props.selectedBtn == 12 ? "selectedMnuBtn" : ""}`} variant="contained" onClick={() => props.showAllOpen(12)}>
                        פתוחות הכל
                    </Button>
                    {/* <Button className={`btnBigMnu ${props.selectedBtn == 9 ? "selectedMnuBtn" : ""}`} variant="contained" onClick={() => refreshTheList(9)}>
                        מתחילת החודש
                    </Button> */}
                    <Button className={`btnBigMnu ${props.selectedBtn == 10 ? "selectedMnuBtn" : ""}`}
                        variant="contained" onClick={() => { props.setShowBetweenDts(!props.showBetweenDts); refreshTheList(10) }}>
                        לפי תאריכים
                    </Button>



                    <div className={`spaceTop ${(props.showBetweenDts) ? "" : "hideMe"}`}>
                        <div className={"onRight"}>
                            {(props.showBetweenDts) ? <BetweenDates
                                startDTS={props.startDTS} setStartDTS={(dt) => props.setStartDTS(dt)}
                                endDTS={props.endDTS} setEndDTS={(dt) => props.setEndDTS(dt)} /> : ""}
                        </div>
                        <div className={"onRight spaceTopBig"}>
                            <Button className={`btnBigMnu onRight
                     ${props.selectedBtn == 11 ? "selectedMnuBtn" : ""}`} variant="contained" onClick={() => refreshTheList(11)}>
                                חפש
                            </Button></div>
                    </div>


                </div>
                {/* <div className={"btnMnuTop onLeft"}>
            <Link to={`/Order`}>
                <Button className={"btnAddItm"} variant="contained"
                    startIcon={<AddBoxOutlined style={{ color: 'white' }} />}>
                    חדש
                </Button>
            </Link>
        </div> */}
            </Stack>

        </div>
    )
}

export default BuisTollBar;

